import { textde } from './locales.de'
import { texten } from './locales.en'
import { textpl } from './locales.pl'

export const messages = {
  de: textde,
  en: texten,
  pl: textpl,
}

import { createI18n } from 'vue-i18n'
const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'de',
  fallbackLocale: 'de',
  messages,
})

export default i18n
